import { render, staticRenderFns } from "./Attivita.vue?vue&type=template&id=d2e4aa4a&scoped=true&"
import script from "./Attivita.vue?vue&type=script&lang=js&"
export * from "./Attivita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e4aa4a",
  null
  
)

export default component.exports